const PERIOD_FIRST_HALF = 1;
const PERIOD_SECOND_HALF = 2;
const PERIOD_EXTRA_TIME_FIRST_HALF = 3;
const PERIOD_EXTRA_TIME_SECOND_HALF = 4;
const PERIOD_PENALTIES = 5;

export const PERIODS = [
  PERIOD_FIRST_HALF,
  PERIOD_SECOND_HALF,
  PERIOD_EXTRA_TIME_FIRST_HALF,
  PERIOD_EXTRA_TIME_SECOND_HALF,
  PERIOD_PENALTIES,
] as const;
